import { render } from "./MetadataList.vue?vue&type=template&id=fe12adba"
import script from "./MetadataList.vue?vue&type=script&lang=js"
export * from "./MetadataList.vue?vue&type=script&lang=js"

import exportComponent from "/Users/jjviglio/OpenMCT/openmct/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__